module.exports = __webpack_public_path__ + "static/media/  (178).a78ef487.jpg";